// PredictedScoreCard

import React, {useRef, useState} from "react";
import Card from "react-bootstrap/Card";

import IconArrowUp from "../../assets/images/eoro-2024/icon-arrow-up.svg";
import IconArrowDown from "../../assets/images/eoro-2024/icon-arrow-down.svg";
import moment from "moment-timezone";

const PredictedScoreCard = (props) => {
    const {
        isMobile,
        match,
        selection,
        setSelection,

    } = props;

    // const [selections, setSelections] = useState([]);
    // console.log("match here in modal >>>", match);
    // console.log("selections >>>", selection)

    const updateSelection = (localTeamScore, visitorTeamScore) => {
        const updatedSelection = {
            match_id: match.id,
            local_team_score: localTeamScore,
            visitor_team_score: visitorTeamScore,
        };
        setSelection(updatedSelection);
    };

    const handleScoreUpdate = (team, increment) => {
        const localTeamScore = team === 'local' ? Math.max((selection?.local_team_score || 0) + increment, 0) : (selection?.local_team_score || 0);
        const visitorTeamScore = team === 'visitor' ? Math.max((selection?.visitor_team_score || 0) + increment, 0) : (selection?.visitor_team_score || 0);
        updateSelection(localTeamScore, visitorTeamScore);
    };

    const renderLocalTeam = (value) => {
        return (
            <>

                <div className={"d-flex flex-row align-items-center w-100"}>
                    <div className={"d-flex flex-column align-items-center w-100"}>
                        <img
                            src={value?.local_team?.icon}
                            className=""
                            alt={value?.local_team?.name}
                            height={50}
                            width={50}
                        />
                        <div
                            className={`fw-300 cabin text-uppercase ${isMobile ? "font-13" : "font-13"}`}>{value?.local_team?.name}</div>
                    </div>
                </div>
            </>
        )

    }

    const renderCenterContent = (value) => {
        return (
            <div className={"d-flex flex-row align-items-center w-100 py-2 justify-content-between gap-2"}>
                <div className={"d-flex flex-column gap-2"}>
                    <img
                        // role={"button"}
                        src={IconArrowUp}
                        alt={"icon"}
                        height={30}
                        // onClick={() => handleScoreUpdate('local', 1, value?.id)}
                    />
                    <img
                        // role={"button"}
                        src={IconArrowDown}
                        alt={"icon"}
                        height={30}
                        // onClick={() => handleScoreUpdate('local', -1, value?.id)}
                    />
                </div>
                <div
                    className={`d-flex flex-row gap-1 align-items-center fw-900 cabin w-100 justify-content-center ${isMobile ? "font-20" : "font-30"}`}
                >
                    <div>{value?.local_team?.prediction}</div>
                    <div>-</div>
                    <div>{value?.visitor_team?.prediction}</div>
                </div>
                <div className={"d-flex flex-column gap-2"}>
                    <img
                        // role={"button"}
                        src={IconArrowUp}
                        alt={"icon"}
                        height={30}
                        // onClick={() => handleScoreUpdate('visitor', 1, value?.id)}
                    />
                    <img
                        // role={"button"}
                        src={IconArrowDown}
                        alt={"icon"}
                        height={30}
                        // onClick={() => handleScoreUpdate('visitor', -1, value?.id)}
                    />
                </div>
            </div>
        );
    };

    const renderVisitorTeam = (value) => {
        return (
            <>
                <div className={"d-flex flex-row align-items-center w-100"}>
                    <div className={"d-flex flex-column align-items-center w-100"}>
                        <img
                            src={value?.visitor_team?.icon}
                            className=""
                            alt={value?.visitor_team?.name}
                            height={50}
                            width={50}
                        />
                        <div
                            className={`fw-300 cabin text-uppercase ${isMobile ? "font-13" : "font-13"}`}>{value?.visitor_team?.name}</div>
                    </div>
                </div>

            </>
        )
    }

    const renderMobile = () => {
        return (
            <>
                <Card className={"rounded-4 d-flex align-items-center mb-3 predict-card border-0"}>
                    <Card.Header
                        className={`d-flex w-100 justify-content-center align-items-center border-0 p-0 m-0 bg-transparent`}
                    >
                        <div
                            className={`text-uppercase w-fit px-4  border-top-0 fw-400 font-13 text-white text-center bg-skins-winning `}
                        >
                            {moment(match?.datetime).format("dddd DD MMMM")}
                            <span className={"mx-1"}>|</span>
                            {
                                match?.local_team_group
                            }
                        </div>
                    </Card.Header>
                    <Card.Body className={`w-100 d-flex flex-column p-0 m-0`}>
                        <div className={"d-flex flex-row align-items-center justify-content-evenly my-2"}>
                            {renderLocalTeam(match)}
                            {renderCenterContent(match)}
                            {renderVisitorTeam(match)}
                        </div>
                    </Card.Body>
                </Card>
            </>
        );
    }

    const renderDesktop = () => {
        return (
            <>
                <Card className={"rounded-4 d-flex align-items-center mb-3 predict-card border-0"}>
                    <Card.Header
                        className={`d-flex w-100 justify-content-center align-items-center border-0 p-0 m-0 bg-transparent`}
                    >
                        <div
                            className={`text-uppercase w-fit px-4  border-top-0 fw-400 font-13 text-white text-center bg-skins-winning `}
                        >
                            {moment(match?.datetime).format("dddd DD MMMM")}
                            <span className={"mx-1"}>|</span>
                            {
                                match?.local_team_group
                            }
                        </div>
                    </Card.Header>
                    <Card.Body className={`w-100 d-flex flex-column p-0 m-0`}>
                        <div className={"d-flex flex-row align-items-center justify-content-evenly my-2"}>
                            {renderLocalTeam(match)}
                            {renderCenterContent(match)}
                            {renderVisitorTeam(match)}
                        </div>
                    </Card.Body>
                </Card>

            </>
        );
    }
    const render = () => {
        return (
            <section>
                {isMobile ? renderMobile() : renderDesktop()}
            </section>
        );
    }

    return render();
}

export default PredictedScoreCard;


